module.exports = __webpack_public_path__ + "static/media/photography.4e101f5c.jpg";